import React, { useContext } from 'react';
import NoResultsFound from 'components/NoResultsFound/NoResultsFound';
import NoFiltersChangePosition from 'components/NoFiltersChangePosition/NoFiltersChangePosition';
import { ChangePositionControlPanel } from './components/ChangePositionControlPanel/ChangePositionControlPanel';
import { ChangePositionList } from './components/ChangePositionList/ChangePositionList';
import { AdditionalRestaurantsModal } from './components/AdditionalRestaurantsModal/AdditionalRestaurantsModal';
import { ModalWindows } from './components/ModalWindows/ModalWindows';
import { BtnBlock } from './components/BtnBlock';
import { AppContext, IAppContext } from 'appState/appContext';
import {
	ChangeDishPositionContext,
	IChangeDishPositionContext,
} from '../../changeDishPositionState/changeDishPositionContext';
import style from './ChangeDishPosition.module.scss';

export const ChangeDishPosition: React.FC = () => {
	const { positionsData, IDSelectedSubCategory } = useContext<IChangeDishPositionContext>(ChangeDishPositionContext);
	const { isLoading } = useContext<IAppContext>(AppContext);

	return (
		<div className={style.container} data-test="ChangeDishPosition">
			<ChangePositionControlPanel />
			{positionsData?.length ? (
				<>
					<ChangePositionList />
					<BtnBlock />
					<ModalWindows />
					<AdditionalRestaurantsModal />
				</>
			) : (
				<NoResultsFound isVisible={!isLoading && !!IDSelectedSubCategory} />
			)}
			<NoFiltersChangePosition isVisible={!IDSelectedSubCategory} />
		</div>
	);
};
